export default "__VITE_ASSET__g6xafybX__"